export const VolunteerRegistrationPreviewSelector = ({
  volunteerRegistrationPreviewStore: { VolunteerRegistrationPreviewData }
}) => VolunteerRegistrationPreviewData;
export default VolunteerRegistrationPreviewSelector;
